var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"socs"},_vm._l((_vm.links),function(item){return _c('a',_vm._b({key:item.title,domProps:{"innerHTML":_vm._s(require(("@/assets/img/" + (item.title) + "-green.svg")))}},'a',item,false))}),0)}
var staticRenderFns = []

export { render, staticRenderFns }